import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignalR } from '../../contexts/SignalRProvider.tsx';
import './ResultPage.css';

const ResultPage: React.FC = () => {
  const navigate = useNavigate();
  const signalRContext = useSignalR();

  const [message, setMessage] = useState<string | null>(null);
  const [symbol, setSymbol] = useState<string>('BTC/USDT');
  const [settlementPrice, setSettlementPrice] = useState<number | null>(null);
  const [tradeDirection, setTradeDirection] = useState<string | null>(null);
  const [amount, setAmount] = useState<number | null>(null);
  const [settlementTime, setSettlementTime] = useState<string>('30s');

  useEffect(() => {
    if (signalRContext && signalRContext.connection) {
      const { connection } = signalRContext;

      connection.on('TradeResult', (type: string, receivedMessage: string) => {
        setMessage(receivedMessage);
        setTradeDirection(type);
        // Try to parse common fields if present in the incoming message
        const priceMatch = receivedMessage.match(/(Settlement\s*Price|Price)\s*[:=-]?\s*(\d+(?:\.\d+)?)/i);
        if (priceMatch) {
          setSettlementPrice(parseFloat(priceMatch[2]));
        }
        const amountMatch = receivedMessage.match(/Amount\s*[:=-]?\s*\$?\s*(\d+(?:\.\d+)?)/i);
        if (amountMatch) {
          setAmount(parseFloat(amountMatch[1]));
        }
        const symbolMatch = receivedMessage.match(/([A-Z]{2,5}\/[A-Z]{2,5})/);
        if (symbolMatch) {
          setSymbol(symbolMatch[1]);
        }
        const timeMatch = receivedMessage.match(/(\d+\s*s|\d+\s*sec|\d+\s*seconds)/i);
        if (timeMatch) {
          setSettlementTime(timeMatch[1].replace(/sec(onds)?/i, 's'));
        }
      });

      return () => {
        connection.off('TradeResult');
      };
    }
  }, [signalRContext]);

  const profitLoss = useMemo(() => {
    if (!message) return null;
    const m = message.match(/-?\$?\s*(-?\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }, [message]);

  const isLoss = profitLoss !== null ? profitLoss < 0 : false;

  return (
    <div className="result-page">
      <div className="result-card">
        <div className="result-card__header">
          <h2 className="result-card__title">{symbol}</h2>
          <button className="result-card__close" aria-label="Close" onClick={() => navigate('/')}>×</button>
        </div>
        <div className="result-card__body">
          <div className="profit-loss-row">
            <span className="profit-loss-row__label">Profit And Loss</span>
            <span className={`profit-loss-row__value ${isLoss ? 'negative' : 'positive'}`}>
              {profitLoss !== null ? `$ ${profitLoss.toFixed(2)}` : (message ?? 'Waiting for trade result...')}
            </span>
          </div>

          <div className="details-grid">
            <div className="details-grid__row">
              <span>Settlement Price</span>
              <span>{settlementPrice !== null ? settlementPrice.toFixed(2) : '--'}</span>
            </div>
            <div className="details-grid__row">
              <span>Trade Direction</span>
              <span>{tradeDirection ?? '--'}</span>
            </div>
            <div className="details-grid__row">
              <span>Amount</span>
              <span>{amount !== null ? `$ ${amount.toFixed(2)}` : '--'}</span>
            </div>
            <div className="details-grid__row">
              <span>Settlement time</span>
              <span>{settlementTime}</span>
            </div>
          </div>
        </div>
        <div className="result-card__footer">
          <button className="btn btn-primary" onClick={() => navigate('/')}>Continue Ordering</button>
          <button className="btn btn-secondary" onClick={() => navigate('/')}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ResultPage;
